/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

export default {
  STOP_PREVIEW_KEYWORD: 'STOP_PREVIEW',
  DIGITAL_ZOOM_INCREMENT: 4,
  CORE_URL: null,
  IAM_URL: null,
  IAM_CLIENT_ID: 'core',
  PIMS_URL: null,
  APPENGINE_URL: null,
  CBIR_URL: null,
  SAM_URL: null,
  CYTOMINE_DEFAULT_REALM: 'zaya',
  CYTOMINE_TENANT_ALLOWLIST: 'zaya',
  CYTOMINE_TENANT_REALM_MAP: null,
  // Default true (production = HTTPS-on-both-sides, the adapter's iframe works fine and
  // gives cross-tab silent logout detection). Set to false in local dev where the IdP is
  // HTTP and the SPA is HTTPS — the iframe would be blocked by the mixed-content rule.
  KEYCLOAK_CHECK_LOGIN_IFRAME: true,
  // --- resumable upload (tus, spec 2026-08-18) --------------------------------------------
  // KILL SWITCH. false = the Storage page uses the legacy single POST, which is the proven
  // path. Flipping this needs only a web-ui restart: no image rebuild, no PIMS rollback.
  TUS_ENABLED: false,
  // Bytes per chunk. MUST be set: tus-js-client defaults to Infinity (one request), which would
  // reproduce the very problem this feature fixes. 64 MiB keeps the request rate far below the
  // router's 1s/200rps window while bounding how much is re-sent after an interruption.
  TUS_CHUNK_SIZE_BYTES: 67108864,
  // Automatic retry backoff, in ms. This is where most of the practical benefit lives: a
  // transient blip is retried without the user noticing.
  TUS_RETRY_DELAYS: '0,3000,6000,12000,24000',
  // Concurrent uploads. At ~10 Mbps, running several 100 GB files at once means NOTHING
  // finishes for days and every file is exposed to interruption; one at a time makes the first
  // slide usable in hours.
  TUS_MAX_CONCURRENT_UPLOADS: 1,
  ACTIVE_TENANT: null,
  // features switches
  APPENGINE_ENABLED: false,
  // Viewer dock layout (2026-09-03): the Images and Annotation-list panels dock LEFT and push
  // the WSI right instead of floating over it from the bottom. Set to false (configuration.json,
  // helm-rendered) to roll back to the bottom-tab behaviour without a rebuild.
  VIEWER_DOCK_LAYOUT: true,
  PRELOADED_SLICES: 50,
  MAX_MERGEABLE_CHANNELS: 36,
  // Refresh intervals (expressed in milliseconds)
  VIEWER_ANNOTATIONS_REFRESH_INTERVAL: 10000,
  MEMBERS_ACTIVITY_REFRESH_INTERVAL: 30000,
  PING_INTERVAL: 20000, // should be lower than 30 seconds (otherwise, not counted in backend)
  TASK_REFRESH_INTERVAL: 2000,
  STORAGE_REFRESH_INTERVAL: 10000,
  // Deliberately slower than the table refresh: PIMS /disk-usage also computes a
  // recursive directory size, so polling it at 10s would walk the slide volume six
  // times a minute. A capacity gauge does not need that resolution.
  STORAGE_USAGE_REFRESH_INTERVAL: 60000,
  ONGOING_UPLOAD_REFRESH_INTERVAL: 500,
  SAVE_POSITION_IN_IMAGE_INTERVAL: 5000, // position also stored each time the user moves in the image
  BROADCASTING_USERS_REFRESH_INTERVAL: 10000,
  TRACKING_REFRESH_INTERVAL: 500,
  ANNOTATION_STROKE_COLOR: [0, 0, 0, 1],
  ANNOTATION_STROKE_SELECT_COLOR: [0, 153, 255, 1],
  MAX_IMAGES_FOR_FILTER: 50000,
  // ---
  IDLE_DURATION: 120, // if the user does not move his mouse on the page during this duration, he is considered as inactive - no more ping (expressed in seconds)
  PREFIX_HIDDEN_PROPERTY_KEY: '@',
  DEFAULT_PROPERTY_KEY: '@DEFAULT_PROPERTY',
  DEFAULT_IMAGE_CONTROLS_STEP: 2,
  CATEGORY_ITEMS_PER_BATCH: 10,
  ANNOTATIONS_MAX_ITEMS_PER_CATEGORY: 10,
  // To keep the WebSockets alive by sending the broadcaster viewer position
  WS_POSITION_KEEP_ALIVE_INTERVAL: 10000,
  CYTOMINE_UPLOAD_URI: '/upload',
};
